import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-generic-contact-details',
    templateUrl: './pc-generic-contact-details.component.html',
    styleUrls: ['./pc-generic-contact-details.component.scss'],
    standalone: false
})
export class PCGenericContactDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
